import { getClosedWidgetEditState } from '../helpers/webDashboardEditState';
import { saveWidgetSettings } from '../layout/webDashboardSaveWidgetSettings';

export const FONT_SIZE_PROP_KEYS = [
	'labelFontSize',
	'valueFontSize',
	'titleFontSize',
	'assetNameFontSize',
	'datastreamLabelFontSize',
	'titleSize',
	'datastreamTitleSize',
	'valueSize',
	'dayLabelFontSize',
	'statusFontSize',
	'switchSize',
	'buttonSize',
	'keyFontSize',
	'strokeWidth',
	'bend',
];

export const createSettingsHandlers = ({
	saveWidgetSettingsArgs,
	setEdit,
}) => ({
	handleCancelWidgetSettings: () => setEdit(getClosedWidgetEditState()),
	handleSaveWidgetSettings: () => saveWidgetSettings(saveWidgetSettingsArgs),
});

export const sanitizeWidgetFontSizeProps = (props = {}) => {
	const nextProps = { ...props };
	FONT_SIZE_PROP_KEYS.forEach((key) => {
		const value = nextProps[key];
		if (value === '' || value === null || value === undefined) {
			delete nextProps[key];
			return;
		}

		const parsed = Number(String(value).trim());
		if (!Number.isFinite(parsed) || parsed <= 0) {
			delete nextProps[key];
			return;
		}

		nextProps[key] = Math.round(parsed);
	});
	return nextProps;
};

export const createEditPropHandlers = ({
	edit,
	setEdit,
}) => {
	const updateEditProp = (key, value) => {
		setEdit(prev => ({
			...prev,
			props: { ...(prev.props || {}), [key]: value }
		}));
	};

	const removeEditProp = (key) => {
		setEdit(prev => {
			const nextProps = { ...(prev.props || {}) };
			delete nextProps[key];
			return {
				...prev,
				props: nextProps
			};
		});
	};

	return {
		updateEditProp,
		removeEditProp,
		handleFontSizeChange: (key, rawValue) => {
			if (rawValue === '') {
				updateEditProp(key, '');
				return;
			}

			if (!/^\d*\.?\d*$/.test(String(rawValue))) return;
			updateEditProp(key, rawValue);
		},
		handleFontSizeBlur: (key) => {
			if (edit?.props?.[key] === '') {
				removeEditProp(key);
			}
		},
		sanitizeWidgetFontSizeProps,
	};
};
